<template>
  <div class="main">
    <div class="return_view">
      <!-- 返回首页 -->
      <p>参加练习</p>
    </div>
    <div class="grey"></div>
    <div class="null_view flex" v-if="dataList.length == 0">
      <div class="null">
        <div>
          <img src="@/assets/student/pracitseNAN.png" alt="" />
          <h2>亲！您现在还没有练习可以进行作答！</h2>
        </div>
        <div class="flex">
          <p @click="cutcoms(1)">看看医学学堂</p>
        </div>
      </div>
    </div>
    <div v-else-if="dataList.length > 0" class="_table" v-loading="loading">
      <el-table
        ref="tabledata"
        :data="dataList"
        style="width: 100%"
        :row-class-name="tableRowClassName"
        :header-cell-style="{
          'background-color': '#8FCBFF',
          color: '#333333',
          height: '60px',
        }"
      >
        <el-table-column label="序号" width="50">
          <template slot-scope="scope">
            {{ scope.$index + 1 + (pageIndex - 1) * eachPageNum }}
          </template>
        </el-table-column>
        <el-table-column
          v-for="(item, index) in formColumns"
          :key="index"
          :prop="item.prop"
          :label="item.label"
          :width="item.width"
          height="150px"
          label-height="50"
          align="center"
        >
        </el-table-column>
        <el-table-column prop="address" label="操作" align="center" width="200">
          <template slot-scope="scope">
            <div class="operation_box">
              <el-button
                type="text"
                size="small"
                :class="buttontColor(scope.row)"
                @click="startPractice(buttonTxt(scope.row), scope.row)"
                >{{ buttonTxt(scope.row) }}</el-button
              >
            </div>
          </template>
        </el-table-column>
      </el-table>
        <!-- 分页 -->
    <div class="foot_box" >
      <div class="foot_pagetions">
        <p>共有{{ total }}条记录，当前第{{ pageIndex }}/{{ pagesun }}页</p>
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page.sync="showpageindex"
          :page-size="eachPageNum"
          :page-sizes="pagesizesarr"
          layout="prev, pager, next,sizes, jumper"
          :total="total"
          class="pagination"
        >
        </el-pagination>
      </div>
    </div>
    </div>
  
  </div>
</template>

<script>
import ksPcApi from "@/api/examPc";
import loginvuex from "@/store/index";
export default {
  data() {
    return {
      dataList: [],
      formColumns: [
        {
          prop: "ExamName",
          label: "考试名称",
        },
        {
          prop: "BeginTime1",
          label: "考试时间",
          width: "280px",
        },
        {
          prop: "SpendTime1",
          label: "考试时长",
        },
        {
          prop: "Score",
          label: "学分",
        },
        {
          prop: "Condition1",
          label: "获取学分条件",
        },
      ],
      pageIndex: 1,
      eachPageNum: 10, //当前也多少条数。
      pagesizesarr: [5, 10, 20, 50, 100],
      showpageindex: 1, //显示的索引盒子
      loading: true,
      total: 100, //总条数
      pagesun: "", //一共多少页,
      loading: false,
    };
  },
  props: ["cutcoms"],
  methods: {
    init() {
      this.getOnlineTest();
    },
    // 表格背景颜色
    tableRowClassName({ row, rowIndex }) {
      if (rowIndex % 2 === 1) {
        return "success-row";
      } else if (rowIndex % 2 === 0) {
        return "warning-row";
      }
      return "";
    },
    // 分页
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
      this.loading = true;
      this.eachPageNum = val;
      this.getOnlineTest(); // 重新发起请求
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.pageIndex = val;
      this.loading = true;
      this.getOnlineTest();
    },
    async getOnlineTest() {
      this.loading = true;
      const obj = {
        pageIndex: this.pageIndex - 1,
        pageShow: this.eachPageNum,
        statusCode: 0, // 0全部 1未开始 2进行中 3学习结束
        AppSource: "ykl",
        guid: JSON.parse(loginvuex.state.userlist).guid,
        userID: JSON.parse(loginvuex.state.userlist).userID,
        hid: JSON.parse(loginvuex.state.userlist).hid,
      };
      const { data } = await ksPcApi.onlineTest(obj);
      console.log(data,'??');
      if (data.Status == 200) {
        setTimeout(() => {
          this.loading = false;
        }, 500);
        this.dataList = data.Data.data.map((item) => {
          item.Score = item.Score ? item.Score : "暂无";
          if(item.Condition == 1){
            item.Condition1 ='看过或参加即可获得'
          }else if (item.Condition == 2){
            item.Condition1 ='完成或及格才可获得'
          }else{
            item.Condition1 ='暂无'
          }
          item.BeginTime1 =
            this.$moment(item.BeginTime).format("YYYY/MM/DD HH:mm") +
            "-" +
            this.$moment(item.EndTime).format("YYYY/MM/DD HH:mm");
          item.SpendTime1 = item.SpendTime + "分";
          return item;
        });
        this.total = data.Data.totalCount;
        this.pagesun = data.Data.totalPage;
      } else {
        this.$message.error(data.data);
      }
    },
    // 开始练习
    startPractice(type, item) {
      if (type === "待练习" || type === "学习结束") {
        let txt = "尚未到达练习开放时间，请耐心等候";
        if (type === "学习结束") {
          txt = "练习时间已结束";
        }
        this.$alert(txt, "温馨提示", {
          confirmButtonText: "确定",
          callback: (action) => {},
        });
      } else {
        // 跳转答题
        this.$parent.rowObj = item;
        this.cutcoms(3);
      }
    },
  },
  computed: {
    buttonTxt() {
      return function (type) {
        const time = Date.parse(new Date());
        const BeginTime = Date.parse(type.BeginTime);
        const EndTime = Date.parse(type.EndTime);
        if (time > EndTime) {
          return "学习结束";
        } else if (type.Status == 1 && time < BeginTime && EndTime > time) {
          return "待练习";
        } else {
          return "开始练习";
        }
      };
    },
    // 禁用
    buttontColor() {
      return function (type) {
        const time = Date.parse(new Date());
        const BeginTime = Date.parse(type.BeginTime);
        const EndTime = Date.parse(type.EndTime);
        if (time > EndTime) {
          return "grey1";
        } else if (type.Status == 1 && time < BeginTime && EndTime > time) {
          return "yellow";
        } else {
          return "green";
        }
      };
    },
  },
  activated() {
    this.init();
  },
};
</script>

<style lang="scss" scoped>
.main {
  min-height: 780px;
}
.flex {
  display: flex;
  justify-content: center;
  align-items: center;
}
.null_view {
  height: 680px;
  // border: 1px solid #000;
 .null > div {
    &:nth-child(1) {
      display: flex;
      > h2 {
        color: #7d7d7d;
        margin-left: 24px;
        font-size: 30px;
      }
    }
    &:nth-child(2) {
      > p {
        margin-top: 68px;
        letter-spacing: 1px;
        font-size: 20px;
        background: #5ac994;
        color: #fff;
        width: 263px;
        height: 68px;
        cursor: pointer;
        line-height: 68px;
        text-align: center;
        align-items: center;
      }
    }
  }
}
._table {
  padding: 24px;
}
::v-deep .el-table th:nth-child(1) {
  opacity: 1;
  border-radius: 4px 0px 0px 4px;
}
::v-deep .el-table th:nth-child(12) {
  opacity: 1;
  border-radius: 0px 4px 4px 0px;
}
::v-deep .el-table th > .cell {
  align-items: center !important;
  text-align: center;
}
.sonbtn {
  border: 1px solid #d9d9d9 !important;
  color: #999999;
}
// 分页
.foot_box {
  position: relative;
  height: 86px;
}
.foot_pagetions {
  display: flex;
  position: absolute;
  right: 16px;
  bottom: 30px;
  p {
    text-align: center;
    line-height: 32px;
    font-family: 微软雅黑;
    color: #949494;
  }
  span {
    line-height: 32px;
    font-size: 15px;
    font-family: PingFang SC;
    font-weight: 400;
    color: #333333;
    b {
      color: #ff0000;
    }
  }
}
.pagination {
  ::v-deep .el-pager {
    li {
      border: 1px solid #d9d9d9;
      margin-right: 8px;
      &.active {
        color: #ffffff;
        background-color: #409eff;
        border: none;
      }
    }
  }
}
::v-deep .el-table__row {
  height: 50px !important;
  td,
  th {
    padding: 0 !important;
  }
}
::v-deep .el-table .warning-row {
  background: #fff !important;
}

::v-deep .el-table .success-row {
  background: #f8fcff !important;
}
::v-deep .el-range-separator {
  color: #eeeeee !important;
}
::v-deep .el-table .redtwo .cell {
  color: #ff0000 !important;
}
::v-deep .el-table .gray .cell {
  color: #aaaaaa !important;
}
::v-deep td > .cell {
  color: #999999;
  font-size: 15px;
}
::v-deep .el-table th {
  width: 100%;
  height: 60px;
  background: #cce7ff;
  color: #333333;
  opacity: 1;
}
.operation_box {
  .el-button {
    font-size: 16px;
  }
}
::v-deep .el-table .red .cell {
  color: #ff0000 !important;
  &::before {
    content: "●";
    width: 20px;
    display: inline-block;
    color: #ff0000;
  }
}
::v-deep .el-table .yellow .cell {
  color: #ffa200 !important;
  &::before {
    content: "●";
    width: 20px;
    display: inline-block;
    color: #ffa200;
  }
}
::v-deep .el-table .green .cell {
  color: #00d254 !important;
  &::before {
    content: "●";
    width: 20px;
    display: inline-block;
    color: #00d254;
  }
}
.icon-tishi {
  display: inline-block;
  // transform: translate(-6px, -5px) scale(0.6);
  &::before {
    color: #cad8d0;
    display: inline-block;
  }
}

.bubbles_box {
  .bubbles_son {
    display: flex !important;
    p {
      flex: 1;
      width: 80px;
    }
  }
}
// .null_view {
//   ::v-deep .el-dialog {
//     width: 300px !important;
//     min-height: 200px !important;
//     border-radius: 5px 5px 0px 0px;
//   }
//   .delete_mian {
//     display: flex;
//     box-sizing: border-box;
//     i {
//       display: inline-block;
//       font-size: 16px !important;
//       color: #ffc664;
//       text-align: center;
//       margin-right: 10px;
//       transform: translateY(4px);
//     }
//     p {
//       text-align: left;
//       font-size: 15px;
//     }
//   }
// }
.everywhere {
  ::v-deep .el-dialog {
    width: 441px !important;
    min-height: 188px !important;
    border-radius: 5px 5px 0px 0px;
  }
  .delete_mian {
    display: flex;
    box-sizing: border-box;
    i {
      display: inline-block;
      font-size: 16px !important;
      color: #ffc664;
      text-align: center;
      margin-right: 10px;
      transform: translateY(4px);
    }
    p {
      text-align: left;
      font-size: 15px;
    }
  }
}
.dialog-footer {
  display: flex;
  justify-content: center;
  align-items: center;
  button:nth-child(1) {
    margin-right: 50px;
  }
}
::v-deep .el-dialog__footer {
  padding: 0;
}
::v-deep.el-dialog__header {
  padding: 16px 20px 10px;
}
::v-deep .el-dialog__header {
  height: 55px;
  opacity: 1;
  border-radius: 5px 5px 0px 0px;
  font-size: 18px;
  font-family: PingFang SC;
  font-weight: bold;
  color: #333333;
  background: linear-gradient(
    180deg,
    #64b5ff 0%,
    rgba(199, 228, 255, 1) 100%
  ) !important;
}
.el-dialog__wrapper {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.exportView {
  ::v-deep .el-dialog {
    width: 340px !important;
    height: 220px !important;
    line-height: 24px;
    border-radius: 5px 5px 0px 0px;
  }
}
.batch_box {
  padding: 0px 24px;
  margin-top: 24px;
  .el-button {
    width: 141px;
    height: 40px;
    color: #ffffff;
    background: #64b5ff;
  }
  span > i {
    font-size: 14px !important;
    margin-right: 5px;
  }
}
.tes {
  color: #c0c4cc !important;
}
.return_view {
  padding: 30px 25px;
  font-size: 24px;
  font-weight: bold;
}
.grey {
  height: 20px;
  background: #eeeeee;
}
.grey1 {
  color: #acacac;
}
.green {
  color: #5ac994;
}
.yellow {
  color: #ffb548;
}
</style>